import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../../axios.js';
import {
  GET_ANNOUCEMENT_LIST,
  ADD_ANNOUCEMENT,
  UPDATE_ANNOUCEMENT_DETAILS_WITH_ID,
  GET_ANNOUCEMENT_DETAILS_WITH_ID,
  DELETE_ANNOUCEMENT_DETAILS_WITH_ID,
  UPDATE_PRIORITY,
  GET_ACTIVE_ANNOUCEMENT_LIST
} from '../../../../Urls.js';

const initialState = {
  announcementsList: { data: [], loader: false },
  announcementsDetails: { data: [], loader: false },
  createAnnouncement: { data: {}, loader: false, successMessage: '' },
  updateAnnouncement: { data: {}, loader: false, successMessage: '' },
  selectedAnnucementItem: {},
  deleteAnnoucementsData: { data: [], loading: false, successMessage: '' },
  draggedAnnoucementsData: { data: [], loading: false, successMessage: '' },
  activeAnnouncementData: { data: [], loading: false }
};

export const getAnnouncementsList = createAsyncThunk('app/get/getAnnouncementsList', async () => {
  const annList = await axios.get(GET_ANNOUCEMENT_LIST);
  return annList;
});

export const getActiveAnnouncement = createAsyncThunk(
  'app/get/getActiveAnnouncement',
  async payload => {
    const params = {};

    if (payload?.city) params.city = payload.city;
    if (payload?.state) params.state = payload.state;
    if (payload?.service_type_code) params.service_type_code = payload.service_type_code;
    if (payload?.pincode) params.pincode = payload.pincode;
    if (payload?.user_type) params.user_type = payload.user_type;
    if (payload?.community) params.community = payload.community;
    const response = await axios.get(GET_ACTIVE_ANNOUCEMENT_LIST, {
      params
    });

    return response.data;
  }
);

export const addAnnouncement = createAsyncThunk('app/get/addAnnouncement', async data => {
  const response = await axios.post(ADD_ANNOUCEMENT, { ...data });
  return response;
});
export const deleteAnnoucements = createAsyncThunk(
  'app/delete/deleteAnnoucements',
  async payload => {
    const response = await axios.delete(
      DELETE_ANNOUCEMENT_DETAILS_WITH_ID + payload.announcement_id
    );
    return response;
  }
);
export const updateAnnouncement = createAsyncThunk('app/get/updateAnnouncement', async data => {
  const response = await axios.put(UPDATE_ANNOUCEMENT_DETAILS_WITH_ID + data?.announcement_id, {
    ...data
  });
  return response;
});
export const updatePriority = createAsyncThunk('app/get/updatePriority', async data => {
  const response = await axios.post(UPDATE_PRIORITY, { ...data });
  return response;
});
export const getAnnouncementsDetails = createAsyncThunk(
  'app/get/announcementsDetails',
  async data => {
    const response = await axios.put(GET_ANNOUCEMENT_DETAILS_WITH_ID + data?.announcement_id);
    return response;
  }
);

export const announcementSlice = createSlice({
  name: 'app/announcementSlice',
  initialState,
  reducers: {
    selectedAnnoucement: (state, action) => {
      state.selectedAnnucementItem = action?.payload;
    },
    clearSuccessMessage: state => {
      state.createAnnouncement.successMessage = '';
      state.updateAnnouncement.successMessage = '';
      state.deleteAnnoucementsData.successMessage = '';
      state.draggedAnnoucementsData.successMessage = '';
    }
  },

  extraReducers: builder => {
    builder
      .addCase(getAnnouncementsList.pending, state => {
        state.announcementsList.loader = true;
      })
      .addCase(getAnnouncementsList.fulfilled, (state, action) => {
        state.announcementsList.loader = false;
        state.announcementsList.data = action?.payload?.data?.data;
      })
      .addCase(getAnnouncementsList.rejected, state => {
        state.announcementsList.loader = false;
      })
      .addCase(getActiveAnnouncement.pending, state => {
        state.activeAnnouncementData.loader = true;
      })
      .addCase(getActiveAnnouncement.fulfilled, (state, action) => {
        state.activeAnnouncementData.loader = false;
        state.activeAnnouncementData.data = action?.payload?.data;
      })
      .addCase(getActiveAnnouncement.rejected, state => {
        state.activeAnnouncementData.loader = false;
      })
      .addCase(getAnnouncementsDetails.pending, state => {
        state.announcementsDetails.loader = true;
      })
      .addCase(getAnnouncementsDetails.fulfilled, (state, action) => {
        state.announcementsDetails.loader = false;
        state.announcementsDetails.data = action?.payload?.data?.data;
      })
      .addCase(getAnnouncementsDetails.rejected, state => {
        state.announcementsDetails.loader = false;
      })
      .addCase(addAnnouncement.pending, state => {
        state.createAnnouncement.loader = true;
      })
      .addCase(addAnnouncement.fulfilled, (state, action) => {
        state.createAnnouncement.loader = false;
        state.createAnnouncement.data = action?.payload?.data?.data;
        state.createAnnouncement.successMessage = 'Annoucement details added successfully!';
      })
      .addCase(addAnnouncement.rejected, state => {
        state.createAnnouncement.loader = false;
        state.createAnnouncement.data = {};
        state.createAnnouncement.successMessage = 'Failed to add Annoucement details!';
      })
      .addCase(updateAnnouncement.pending, state => {
        state.updateAnnouncement.loader = true;
      })
      .addCase(updateAnnouncement.fulfilled, (state, action) => {
        state.updateAnnouncement.loader = false;
        state.updateAnnouncement.data = action?.payload?.data?.data;
        state.updateAnnouncement.successMessage = 'Annoucement details updated successfully!';
      })
      .addCase(updateAnnouncement.rejected, state => {
        state.updateAnnouncement.loader = false;
        state.updateAnnouncement.data = {};
        state.updateAnnouncement.successMessage = 'Failed to update Annoucement details!';
      })
      .addCase(deleteAnnoucements.pending, state => {
        state.deleteAnnoucementsData.loading = true;
      })
      .addCase(deleteAnnoucements.fulfilled, (state, action) => {
        state.deleteAnnoucementsData.loading = false;
        state.deleteAnnoucementsData.data = action?.payload?.data?.data;
        state.deleteAnnoucementsData.successMessage = 'Annoucement deleted successfully!';
      })
      .addCase(deleteAnnoucements.rejected, state => {
        state.deleteAnnoucementsData.loading = false;
        state.deleteAnnoucementsData.successMessage = 'Failed to delete Annoucement .';
      })
      .addCase(updatePriority.pending, state => {
        state.draggedAnnoucementsData.loader = true;
      })
      .addCase(updatePriority.fulfilled, (state, action) => {
        state.draggedAnnoucementsData.loader = false;
        state.draggedAnnoucementsData.data = action?.payload?.data?.data;
        state.draggedAnnoucementsData.successMessage = 'Priority details updated successfully!';
      })
      .addCase(updatePriority.rejected, state => {
        state.draggedAnnoucementsData.loader = false;
        state.draggedAnnoucementsData.data = {};
        state.draggedAnnoucementsData.successMessage = 'Failed to update the priority details!';
      });
  }
});

export const { selectedAnnoucement, clearSuccessMessage } = announcementSlice.actions;

export default announcementSlice.reducer;
